import { scatter } from './scatter';
import { line } from './line';
import { time_series } from './time_series';

const chart = {
	scatter,
	line, 
	time_series
}

export {
	chart
}
